import request from '@/utils/request'

export function getUploadToken(params) {
  return request({
    url: process.env.VUE_APP_PRO_API + 'file_server/oss/getToken/',
    method: 'get',
    params
  })
}

export function uploadVideo(url, data) {
  return request({
    url: url,
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/form-data' }
  })
}

/**
 * @template T
 * @typedef {{code: number, message: string, data: T, traceid: string}} R
 * @typedef {{username: string}} Userinfo
 * @returns {Promise<R<Userinfo>>}
 */
export function getUserinfo() {
  return request({
    url: `user/userinfo`,
    method: 'get'
  })
}

export function get_relationship(username) {
  return request({
    url: `https://access.starmerx.com/api/users/${username}/relationship/`,
    method: 'get'
  })
}

export function logout() {
  window.location.href = `${process.env.VUE_APP_PASSPORT_API}/logout`
}
